module.exports = __webpack_public_path__ + "img/onlineSignMini.aa96e7cc.jpg";